import * as types from './actionTypes';

const setErrorCommon = (message) => (dispatch) => {
    dispatch({ type: types.SET_ERROR_COMMON, message });
};

export {
    setErrorCommon,
};